// Function to convert string to Title Case
export const toTitleCase = (str) => {
    if (!str) return '';
    
    return str.toLowerCase().split(' ').map(word => {
        // Handle special cases like "and", "or", "the" if needed
        const specialWords = ['and', 'or', 'the', 'in', 'on', 'at', 'for'];
        if (specialWords.includes(word)) {
            return word;
        }
        return word.charAt(0).toUpperCase() + word.slice(1);
    }).join(' ');
};


// Formatting location string with better handling of missing data
export const cleanLocationString = (location) => {
    if (!location) return 'Location not specified';
    
    // Split by commas and process each part
    const parts = location.split(',').map(part => part.trim());
    
    // Filter out parts that are just '-' or empty
    const cleanedParts = parts.filter(part => part && part !== '-');
    
    if (cleanedParts.length === 0) return 'Location not specified';
    
    // Join back with commas
    return cleanedParts.join(', ');
};

// Helper functions
export const formatPostedTime = (created) => {
    console.log('Original created value:', created);
    if (!created) return 'Posted recently';
    const postedDate = new Date(created);
    const now = new Date();
    const diffHours = Math.floor((now - postedDate) / (1000 * 60 * 60));
    console.log('Calculated diffHours:', diffHours);
    
    if (diffHours < 24) {
        return `${diffHours} hour${diffHours !== 1 ? 's' : ''} ago`;
    } else {
        const diffDays = Math.floor(diffHours / 24);
        return `${diffDays} day${diffDays !== 1 ? 's' : ''} ago`;
    }
};

export const formatContractType = (contractType) => {
    const types = {
        'permanent': 'Permanent',
        'full_time': 'Full-time',
        'part_time': 'Part-time',
        'contract': 'Contract'
    };
    return types[contractType] || 'Full-time';
};

export const formatSalary = (salary) => {
    if (!salary || (!salary.min && !salary.max)) return 'Salary not specified';
    
    const formatAmount = (amount) => {
        if (!amount) return '';
        if (amount >= 100000) return `₹${(amount / 100000).toFixed(1)}L`;
        if (amount >= 1000) return `₹${(amount / 1000).toFixed(0)}k`;
        return `₹${amount}`;
    };
    
    if (salary.min && salary.max) {
        return `${formatAmount(salary.min)} - ${formatAmount(salary.max)}`;
    } else if (salary.min) {
        return `From ${formatAmount(salary.min)}`;
    } else if (salary.max) {
        return `Up to ${formatAmount(salary.max)}`;
    }
    
    return 'Salary not specified';
};

export const formatExperience = (experience) => {
    if (!experience) return 'Experience not specified';

    /*
      "experience": {
        "min": 6,
        "max": 10,
        "unit": "years"
      },
    */
    const { min, max, unit } = experience;
    if (min && max) {
        return `${min} - ${max} ${unit}`;
    } else if (min) {
        return `${min} ${unit}`;
    } else if (max) {
        return `Up to ${max} ${unit}`;
    }

    return 'Experience not specified';    
};

export const getJobIcon = (category) => {
    const icons = {
        'accounting-finance-jobs': 'fa-calculator',
        'healthcare-nursing-jobs': 'fa-heartbeat',
        'agritech': 'fa-seedling',
        'it-jobs': 'fa-code',
        'engineering-jobs': 'fa-cogs',
        'sales-jobs': 'fa-chart-line',
        'marketing-jobs': 'fa-bullhorn',
        'design-jobs': 'fa-paint-brush',
        'hr-jobs': 'fa-users'
    };
    return icons[category] || 'fa-briefcase';
};

export const getJobIconBgColor = (category) => {
    const bgColors = {
        'accounting-finance-jobs': 'bg-emerald-500/10',
        'healthcare-nursing-jobs': 'bg-rose-500/10',
        'agritech': 'bg-green-500/10',
        'it-jobs': 'bg-sky-500/10',
        'engineering-jobs': 'bg-cyan-500/10',
        'sales-jobs': 'bg-amber-500/10',
        'marketing-jobs': 'bg-pink-500/10',
        'design-jobs': 'bg-orange-500/10',
        'hr-jobs': 'bg-blue-500/10'
    };
    return bgColors[category] || 'bg-gray-500/10';
};

export const getJobIconColor = (category) => {
    const colors = {
        'accounting-finance-jobs': '#10b981',
        'healthcare-nursing-jobs': '#f43f5e',
        'agritech': '#22c55e',
        'it-jobs': '#0096C7',
        'engineering-jobs': '#06D6A0',
        'sales-jobs': '#FFD166',
        'marketing-jobs': '#EF476F',
        'design-jobs': '#FF9F1C',
        'finance-jobs': '#7209B7',
        'hr-jobs': '#4CC9F0'
    };
    return colors[category] || '#0096C7';
};

// Function to remove background colors from HTML content
export const cleanHtmlContent = (html) => {
    if (!html) return '';
    
    // Create a temporary DOM element
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    
    // Remove ALL inline styles from all elements
    const allElements = tempDiv.getElementsByTagName('*');
    for (let element of allElements) {
        // Remove all inline style attributes completely
        element.removeAttribute('style');
        element.removeAttribute('bgcolor');
        element.removeAttribute('color');
        
        // Remove ALL classes - we don't want any external styling
        element.removeAttribute('class');
        
        // Remove font tags and their attributes
        if (element.tagName === 'FONT') {
            element.removeAttribute('face');
            element.removeAttribute('size');
            element.removeAttribute('color');
        }
        
        // Remove common formatting attributes
        element.removeAttribute('align');
        element.removeAttribute('valign');
        element.removeAttribute('border');
        element.removeAttribute('cellpadding');
        element.removeAttribute('cellspacing');
    }
    
    // Remove any style tags completely
    const styleTags = tempDiv.getElementsByTagName('style');
    while (styleTags.length > 0) {
        styleTags[0].parentNode.removeChild(styleTags[0]);
    }
    
    // Remove link tags (external stylesheets)
    const linkTags = tempDiv.getElementsByTagName('link');
    while (linkTags.length > 0) {
        linkTags[0].parentNode.removeChild(linkTags[0]);
    }
    
    // Return the cleaned HTML
    return tempDiv.innerHTML;
};